/**
 * File Upload Component translations
 * File upload UI text
 */

import { LANGUAGES } from '../config';

export const fileUploadComponentTranslations = {
  [LANGUAGES.EN]: {
    dropzoneText: 'Drag and drop files here, or click to select files',
    textLabel: 'Or paste text directly',
    acceptedFormats: 'Accepted formats: PDF, DOC, DOCX, TXT',
    uploadedFiles: 'Uploaded Files',
    dragAndDrop: 'Drag and drop here',
    browse: 'Browse',
    orText: 'OR',
    pasteText: 'Paste text',
    maxFileSize: 'Maximum file size: 10MB',
    fileTooLarge: 'File is too large. Maximum size is 10MB.',
    invalidFileType: 'Invalid file type. Please upload a PDF or Word document.',
    uploadFailed: 'Upload failed. Please try again.',
    downloadFailed: 'Download failed. Please try again.',
    companyNameRequired: 'Company Name is required.',
    uploadCVFiles: 'Upload CV files or drag and drop them here',
    uploadJobFiles: 'Upload job posting files or drag and drop them here',
    uploadCompanyInfo: 'Upload company information files or drag and drop them here',
    pasteCVText: 'Or paste CV text directly',
    pasteJobText: 'Or paste job posting text directly',
    enterCompanyName: 'Company Name',
    optionalFiles: 'Optional - These files will be used to enrich the research content'
  },
  [LANGUAGES.FR]: {
    dropzoneText: 'Glissez-déposez des fichiers ici, ou cliquez pour sélectionner des fichiers',
    textLabel: 'Ou collez le texte directement',
    acceptedFormats: 'Formats acceptés: PDF, DOC, DOCX, TXT',
    uploadedFiles: 'Fichiers téléchargés',
    dragAndDrop: 'Glissez-déposez ici',
    browse: 'Parcourir',
    orText: 'OU',
    pasteText: 'Coller le texte',
    maxFileSize: 'Taille maximale du fichier: 10MB',
    fileTooLarge: 'Le fichier est trop volumineux. La taille maximale est de 10MB.',
    invalidFileType: 'Type de fichier non pris en charge. Veuillez télécharger un PDF ou un document Word.',
    uploadFailed: 'Échec du téléchargement. Veuillez réessayer.',
    downloadFailed: 'Échec du téléchargement. Veuillez réessayer.',
    companyNameRequired: 'Le nom de l\'entreprise est requis.',
    uploadCVFiles: 'Téléchargez des fichiers CV ou glissez-les ici',
    uploadJobFiles: 'Téléchargez des fichiers d\'offre d\'emploi ou glissez-les ici',
    uploadCompanyInfo: 'Téléchargez des fichiers d\'information sur l\'entreprise ou glissez-les ici',
    pasteCVText: 'Ou collez le texte du CV directement',
    pasteJobText: 'Ou collez le texte de l\'offre d\'emploi directement',
    enterCompanyName: 'Nom de l\'entreprise',
    optionalFiles: 'Optionnel - Ces fichiers seront utilisés pour enrichir le contenu de recherche'
  }
};
